module.exports = __webpack_public_path__ + "static/viky-d81f8e9ca3d4ed2c65e1f1f0e00393ef.jpg";